<wl-share-buttons [items]="items"></wl-share-buttons>
